import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { Pagination } from '@gemini/ui';
import { getPaginationCount } from './getPaginationCount';
export const BasePagination = ({ totalCount, page, pageSize, ...props }) => {
    const count = getPaginationCount(totalCount, pageSize);
    return (_jsx(Box, { alignSelf: "center", children: _jsx(Pagination, { ...props, type: "button", count: count, page: page, sectionName: "pagination" }) }));
};
